import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
import { BannerService } from '../../services/banner.service';
import { MenuItem } from 'primeng/api';
@Component({
  selector: 'app-data-protection-policy',
  templateUrl: './data-protection-policy.component.html',
  styleUrls: ['./data-protection-policy.component.scss']
})
export class DataProtectionPolicyComponent implements OnInit, OnDestroy {
  items:MenuItem[];
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  public bannerImageList: any[] = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  constructor(private cmsmoduleService: CmsmoduleService, private bannerService: BannerService, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.items=[
      {routerLink:"/", label: 'Home'},
      {label:"Data Protection Policy" }
    ]
    this.getCmsContent();
    this.renderer.addClass(document.body, 'stickyHeaderMobile');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'stickyHeaderMobile');
  }

  preprocessHtml(html: string): string {
    if (!html) return '';
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const body = doc.body;
      const children = Array.from(body.children);
      
      let newHtml = '';
      let currentGroupHtml = '';
      let currentHeadingHtml = '';
      
      const flushGroup = () => {
        if (currentHeadingHtml) {
          newHtml += `<h3 class="sub-title">${currentHeadingHtml}</h3>`;
        }
        if (currentGroupHtml.trim()) {
          newHtml += `<div class="list-alpha">${currentGroupHtml}</div>`;
        }
        currentGroupHtml = '';
        currentHeadingHtml = '';
      };
      
      children.forEach((child) => {
        const tagName = child.tagName.toLowerCase();
        const textContent = child.textContent || '';
        const innerHtml = child.innerHTML.trim();
        
        // Ignore empty line spacers
        if (innerHtml === '<br>' || innerHtml === '' || textContent.trim() === '') {
          if (tagName === 'p' && !child.querySelector('strong') && !child.querySelector('b')) {
            return;
          }
        }

        if (tagName === 'h1') {
          flushGroup();
          newHtml += `<div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                        <div class="section-title-text text-center pt-4">
                          <h1 class="title">${child.innerHTML}</h1>
                        </div>
                      </div>`;
          return;
        }
        
        // Check if heading
        const isHeading = tagName === 'h2' || tagName === 'h3' || tagName === 'h4' || 
                          (tagName === 'p' && child.querySelector('strong') && /^\d+\.\s+[A-Z\s]+$/.test(textContent.trim()));
                          
        if (isHeading) {
          flushGroup();
          
          let headingText = child.innerHTML.replace(/<\/?strong>/gi, '').replace(/<\/?b>/gi, '').trim();
          
          // Format heading to Title Case
          headingText = headingText.replace(/\b([A-Z]+)\b/g, (match) => {
            if (match.toUpperCase() === 'ITF' || match.toUpperCase() === 'TPL') {
              return match.toUpperCase();
            }
            return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
          });
          headingText = headingText.replace(/\bTpl\b/gi, 'TPL');
          headingText = headingText.replace(/\bItf\b/gi, 'ITF');
          
          currentHeadingHtml = headingText;
        } else {
          // Identify sublist items starting with roman numerals or standard list elements
          const isSubItem = /^[i|v|x]+\.\s+/i.test(textContent.trim());
          if (isSubItem) {
            child.classList.add('sub-list-item');
          }
          currentGroupHtml += child.outerHTML;
        }
      });
      
      flushGroup();
      return newHtml;
    } catch (e) {
      console.error('Error preprocessing CMS HTML:', e);
      return html;
    }
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=Dataprotectionpolicies";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.preprocessHtml(this.cmsContent['cmsDescription']);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
}
